export default "__VITE_ASSET__44279836__"